function getCount(cart) {
    return cart.lineItems.reduce((total, val) => parseInt(total) + parseInt(val.qty), 0);
}

export default function updateCount(cart) {
    let cartCount = document.getElementById("cart-count");

    if (cart != null && cartCount != null) {
        let count = getCount(cart);
        cartCount.innerHTML = count > 0 ? count : "";
    }
}
